import React, { type FC, type PropsWithChildren, useState } from 'react';
import { ShowMiniatureContext } from './ShowMiniatureContext';

const ShowMiniatureContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [showMiniature, setShowMiniature] = useState(true);

  const handleSetShowMiniature = (value: boolean) => {
    setShowMiniature(value);
  };

  return (
    <ShowMiniatureContext.Provider
      value={{ showMiniature, setShowMiniature: handleSetShowMiniature }}
    >
      {children}
    </ShowMiniatureContext.Provider>
  );
};

export default ShowMiniatureContextProvider;
